"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcRemote = exports.EXISTING_CONNECTION_TIMEOUT = void 0;
const proto_rpc_1 = require("@streamr/proto-rpc");
const IConnection_1 = require("../../connection/IConnection");
const Connectivity_1 = require("../../helpers/Connectivity");
// Should connect directly to the server, timeout can be low
const WEBSOCKET_CLIENT_TIMEOUT = 5000;
// Requires a WebsocketConnectionRequest to be routed to the client before the connection can be opened
// takes a little bit longer than WEBSOCKET_CLIENT
const WEBSOCKET_SERVER_TIMEOUT = 7500;
// WebRTC connections require lots of signalling to open and might take a longer time.
const WEBRTC_TIMEOUT = 10000;
// default timeout for existing connections
exports.EXISTING_CONNECTION_TIMEOUT = 5000;
const getTimeout = (localPeerDescriptor, remotePeerDescriptor) => {
    const connectionType = (0, Connectivity_1.expectedConnectionType)(localPeerDescriptor, remotePeerDescriptor);
    if (connectionType === IConnection_1.ConnectionType.WEBSOCKET_CLIENT) {
        return WEBSOCKET_CLIENT_TIMEOUT;
    }
    else if (connectionType === IConnection_1.ConnectionType.WEBSOCKET_SERVER) {
        return WEBSOCKET_SERVER_TIMEOUT;
    }
    else if (connectionType === IConnection_1.ConnectionType.WEBRTC) {
        return WEBRTC_TIMEOUT;
    }
    return WEBRTC_TIMEOUT;
};
class RpcRemote {
    localPeerDescriptor;
    remotePeerDescriptor;
    client;
    timeout;
    constructor(localPeerDescriptor, remotePeerDescriptor, rpcCommunicator, 
    // eslint-disable-next-line @typescript-eslint/prefer-function-type
    clientClass, timeout) {
        this.localPeerDescriptor = localPeerDescriptor;
        this.remotePeerDescriptor = remotePeerDescriptor;
        this.client = (0, proto_rpc_1.toProtoRpcClient)(new clientClass(rpcCommunicator.getRpcClientTransport()));
        this.timeout = timeout;
    }
    getPeerDescriptor() {
        return this.remotePeerDescriptor;
    }
    getLocalPeerDescriptor() {
        return this.localPeerDescriptor;
    }
    getClient() {
        return this.client;
    }
    formDhtRpcOptions(opts) {
        return {
            sourceDescriptor: this.localPeerDescriptor,
            targetDescriptor: this.remotePeerDescriptor,
            timeout: this.timeout ?? getTimeout(this.localPeerDescriptor, this.remotePeerDescriptor),
            ...opts
        };
    }
}
exports.RpcRemote = RpcRemote;
//# sourceMappingURL=RpcRemote.js.map